import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/andy-ruiz/banner-image-mobile.webp")